export const INITIAL_ESTATES_REQUEST = "INITIAL_ESTATES_REQUEST";
export const FETCH_ESTATES_SUCCESS = "FETCH_ESTATES_SUCCESS";
export const FINAL_ESTATES_REQUEST = "FINAL_ESTATES_REQUEST";
